<template>
  <div>
    <p v-for="log in logs.list" :key="log.timestamp">
      {{ moment(log.date).locale('ru').format('DD.MM.YYYY HH:mm') }}
      {{ ' ' }}
      {{ log.newStatus.name }}
      {{ log.shownName ? ' (' + log.shownName + ')' : '' }}
      {{ log.description ? ' (' + log.description + ')' : '' }}
    </p>
  </div>
</template>

<script>
import ApplicationLogListDto from '@/common/classes/dto/ApplicationLogListDto'
import moment from 'moment/moment'

export default {
  name: 'ApplicationLogs',

  props: {
    logs: {
      type: ApplicationLogListDto
    }
  },

  data: () => ({ moment })
}
</script>
